import React, { useCallback, useEffect, useRef, useState } from "react";
import { MapControl } from "react-leaflet";
import L from "leaflet";
import { withLeaflet } from "react-leaflet";
import { Button, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRuler } from "@fortawesome/free-solid-svg-icons";

import "../../../libs/Leaflet.PolylineMeasure";
import "../../../libs/Leaflet.PolylineMeasure.css";
import "./WidgetMeasure.scss";
import { TI_MAP_RULER_BUTTON } from "../../../Constants";

export default function WidgetMeasure({ style }) {
  const measureControlRef = useRef();
  const [isMeasuring, setIsMeasuring] = useState(false);

  const onClick = useCallback(() => {
    const measurePlugin = measureControlRef.current.leafletElement;
    measurePlugin._toggleMeasure();
    setIsMeasuring(!!measurePlugin._measuring);
  }, [measureControlRef]);

  useEffect(() => {
    const measurePlugin = measureControlRef.current.leafletElement;
    const keyPressHandler = (e) => {
      if (e.key === "Escape") {
        if (
          measurePlugin._currentLine === undefined ||
          measurePlugin._currentLine === null
        )
          setIsMeasuring(false);
      }
    };
    document.addEventListener("keydown", keyPressHandler);
    return () => {
      document.removeEventListener("keydown", keyPressHandler);
    };
  }, []);

  return (
    <div style={{ ...style }}>
      <Tooltip
        placement="left"
        title={isMeasuring ? "거리 측정 끄기" : "거리 측정 켜기"}
      >
        <Button
          onClick={onClick}
          tabIndex={TI_MAP_RULER_BUTTON}
          shape={"circle"}
          style={{ display: "block", marginBottom: 1 }}
          aria-label="거리 측정 켜기"
        >
          <FontAwesomeIcon icon={faRuler} spin={isMeasuring} />
        </Button>
      </Tooltip>

      <MeasureControl ref={measureControlRef} {...MEASURE_CONTROL_PROPS} />
    </div>
  );
}

const MEASURE_CONTROL_PROPS = {
  unit: "metres",
  showBearings: false,
  showUnitControl: false,
  clearMeasurementsOnStop: true,
  tooltipTextFinish: "클릭하시면 <b>측정중인 거리측정이 종료됩니다.</b><br>",
  tooltipTextDelete:
    "쉬프트(SHIFT)키를 누르고 선택하면 <b>포인트가 삭제됩니다.</b>",
  tooltipTextMove: "마우스 드래그하시면 <b>포인트가 이동됩니다.</b><br>",
  tooltipTextResume: `<br>컨트롤(Ctrl)키를 누르고 선택하면 위치를 연장할 수 있습니다.`,
  tooltipTextAdd:
    "컨트롤(Ctrl)키를 누르고 선택하면 포인트를 추가할 수 있습니다.",
  measureControlTitleOn: "거리측정 켜기",
  measureControlTitleOff: "거리측정 끄기",
  // tooltipTextDraganddelete: `포인트를 선택하고 드래그하면 위치를 옮길 수 있습니다.<br>시프트(Shift)키를 누르고 선택하면 포인트를 제거할 수 있습니다.`,
};

class MeasureControlDefault extends MapControl {
  createLeafletElement(props) {
    return L.control.polylineMeasure(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }
}

const MeasureControl = withLeaflet(MeasureControlDefault);
